<template>
  <div>
    <input
      :placeholder="fileOriginalName ? '' : 'No files selected'"
      type="text"
      class="form-control"
      v-model="fileOriginalName"
      maxlength="1024"/>
    <button
      v-if="fileOriginalName"
      class="btn btn-sm btn-secondary"
      type="button"
      @click="downloadFile">
      <i class="fa fa-download"></i> Download
    </button>
    <button
      class="btn btn-sm btn-secondary"
      type="button"
      @click="chooseFile">
      <i class="fa fa-plus"></i> Upload
    </button>
    <span v-if="uploadPercentage > 0 && uploadPercentage < 100">uploading... {{ uploadPercentage  }}%</span>
    <input style="display: none;" ref="fileInput" type="file" @change="fileSelected">
  </div>
</template>

<script>
import {notify} from 'utils'

export default {
  props: {
    value: {
      required: true
    },
    prefix: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      uploadPercentage: 0
    }
  },
  computed: {
    fileOriginalName () {
      if (this.value && this.value.includes('|')) {
        return this.value.split('|')[0]
      }
      return this.value
    },
    fileHashedName () {
      if (this.value && this.value.includes('|')) {
        return this.value.split('|')[1]
      }
      return 0
    }
  },
  methods: {
    chooseFile () {
      this.$refs.fileInput.click()
    },
    async fileSelected (e) {
      if (!e.target.files || !e.target.files.length) {
        return
      }

      try {
        const value = await this.uploadFile(e.target.files[0])
        this.$emit('input', value)
      } catch (e) {
        notify.error('An error occurred. Please try again')
      }
    },
    async uploadFile (file) {
      const fileName = file.name.replace(/[/\\?%*:|"<> ]/g, '-')
      const response = await this.$http.get('uploads/pre-sign-cloud', {
        params: {
          name: fileName,
          generateHash: 1,
          type: file.type
        }
      })

      const signedUrl = response.data.uri
      const metaData = response.data.metaData

      await this.$http.put(signedUrl, file, {
        headers: {
          'Content-Type': file.type
        },
        withCredentials: false,
        onUploadProgress: e => {
          this.uploadPercentage = Math.floor((e.loaded / e.total) * 100)
        }
      })

      if (metaData['hashedName']) {
        return fileName + '|' + metaData['hashedName']
      }

      return fileName
    },
    async downloadFile () {
      const response = await this.$http.get('downloads/pre-sign-cloud', {
        params: {
          name: this.fileOriginalName,
          hashedName: this.fileHashedName
        }
      })
      window.open(response.data.uri)
    }
  }
}

</script>
